import React from "react";
import styles from "./CommingSoon.module.scss";
import { useTranslation } from "react-i18next";
import CustomButton from "../ui/CustomButton/CustomButton";

interface IComingSoonPopupProps {
  close: () => void;
}

const ComingSoonPopup: React.FC<IComingSoonPopupProps> = ({ close }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.popup}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="66"
          height="66"
          viewBox="0 0 66 66"
          fill="none"
        >
          <g clipPath="url(#clip0_24005_2988)">
            <path
              d="M29.9965 8.15089L12.7812 30.6565M38.3664 12.732L34.8614 8.15063M52.0768 30.6564L41.1056 16.3143M65.0332 57.1518V62.3763C65.0332 63.8433 63.8434 65.0331 62.3764 65.0331H3.62355C2.1566 65.0331 0.966797 63.8433 0.966797 62.3763V33.3131C0.966797 31.8449 2.1566 30.6564 3.62355 30.6564H62.3764C63.8434 30.6564 65.0332 31.8449 65.0332 33.3131V52.64"
              stroke="#19455E"
              strokeWidth="1.93359"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M42.8347 45.0646V35.7809L49.1113 44.8699C49.2277 45.038 49.3524 44.9556 49.3524 44.7511L49.2655 35.7635M26.6721 44.9919L28.3069 35.9345C28.3477 35.7224 28.6436 35.7026 28.7124 35.9073L31.3719 44.9213C31.4363 45.1132 31.7083 45.1118 31.7708 44.9192L34.3394 35.9087C34.4061 35.7033 34.702 35.72 34.7451 35.9316L36.4766 44.9918M39.6629 35.7635V45.0646M59.1304 36.5579C58.3627 36.0388 57.4569 35.7622 56.5303 35.7637C53.9618 35.7637 51.8797 37.8458 51.8797 40.4142C51.8797 42.9827 53.9618 45.0648 56.5303 45.0648C59.0987 45.0648 60.5448 42.9827 60.5448 40.4142H57.7625M12.7068 36.5579C11.9391 36.0388 11.0333 35.7622 10.1066 35.7637C7.53815 35.7637 5.45605 37.8458 5.45605 40.4142C5.45605 42.9827 7.53815 45.0648 10.1066 45.0648C11.1497 45.0648 12.0077 44.7214 12.6589 44.1414C12.794 44.0209 12.9202 43.8908 13.0364 43.752"
              stroke="#19455E"
              strokeWidth="1.93359"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M19.6672 45.0648C22.2356 45.0648 24.3177 42.9827 24.3177 40.4142C24.3177 37.8458 22.2356 35.7637 19.6672 35.7637C17.0987 35.7637 15.0166 37.8458 15.0166 40.4142C15.0166 42.9827 17.0987 45.0648 19.6672 45.0648Z"
              stroke="#19455E"
              strokeWidth="1.93359"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M45.9005 60.6587V51.375L52.1771 60.4639C52.2935 60.632 52.4181 60.5496 52.4181 60.3452L52.3312 51.3576M26.5561 51.3574C29.1032 51.3845 31.158 53.456 31.158 56.0084C31.158 58.5762 29.0762 60.658 26.5071 60.658C23.9393 60.658 21.8574 58.5762 21.8574 56.0084C21.8574 54.9784 22.1926 54.0258 22.7572 53.2562"
              stroke="#19455E"
              strokeWidth="1.93359"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M38.4142 60.6585C40.9827 60.6585 43.0648 58.5764 43.0648 56.008C43.0648 53.4395 40.9827 51.3574 38.4142 51.3574C35.8458 51.3574 33.7637 53.4395 33.7637 56.008C33.7637 58.5764 35.8458 60.6585 38.4142 60.6585Z"
              stroke="#19455E"
              strokeWidth="1.93359"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M19.3146 52.3138C19.3146 52.3138 17.6457 50.9109 15.6775 51.5038C14.0962 51.9801 13.6291 53.7028 14.5078 54.6123C15.2221 55.3515 16.2079 55.5566 17.6308 56.0815C21.0561 57.3449 19.5807 60.6587 16.8233 60.6587C15.4424 60.6587 14.2835 60.054 13.582 59.2799"
              stroke="#19455E"
              strokeWidth="1.93359"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M32.4295 8.97444C34.6407 8.97444 36.4332 7.18192 36.4332 4.97074C36.4332 2.75956 34.6407 0.967041 32.4295 0.967041C30.2183 0.967041 28.4258 2.75956 28.4258 4.97074C28.4258 7.18192 30.2183 8.97444 32.4295 8.97444Z"
              stroke="#19455E"
              strokeWidth="1.93359"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_24005_2988">
              <rect width="66" height="66" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <h3>{t("ComingSoon")}</h3>
        <p>{t("WeWorkingHardToBringYouTheBestExperience")}</p>
        <CustomButton
          text={t("OkThanks")}
          type={"button"}
          typeStyle={"fill"}
          functionOnClick={close}
          style={{
            maxWidth: "165px",
            margin: "0 auto",
          }}
        />
      </div>
    </div>
  );
};

export default ComingSoonPopup;
